export var FriendRequestStatus;
(function (FriendRequestStatus) {
    FriendRequestStatus["PENDING"] = "PENDING";
    FriendRequestStatus["ACCEPTED"] = "ACCEPTED";
    FriendRequestStatus["REJECTED"] = "REJECTED";
    FriendRequestStatus["CANCELLED"] = "CANCELLED";
})(FriendRequestStatus || (FriendRequestStatus = {}));
